import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ServerResponseObject } from '../../../interfaces/ServerResponse';
import { AdminService } from '../../../services/admin.service';
import { GetDataServices } from '../../../interfaces/DataService';
import { CompanyValue } from '../../dialogs/add-user-dataservice-dialog/add-user-dataservice-dialog.component';

@Component({
  selector: 'search-dataservice',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatProgressSpinner,
    ReactiveFormsModule
  ],
  templateUrl: './search-dataservice.component.html',
  styleUrl: './search-dataservice.component.scss'
})
export class SearchDataserviceComponent{
  @Input() searchDataserviceForm!: FormGroup;
  @Input() company!: CompanyValue;

  constructor(private adminService: AdminService) { }

  dataservicesOptions: { id: string; name: string }[] = [];
  private dataserviceSearchTimer: any;

  searchLoading: boolean = false;

  onDataserviceInput(value: string) {
    if (this.dataserviceSearchTimer) clearTimeout(this.dataserviceSearchTimer);
    const q = (value || '').trim();
    if (q.length < 2) {
      this.dataservicesOptions = [];
      return;
    }
    this.dataserviceSearchTimer = setTimeout(() => this.getDataserviceList(q), 350);
  }

  triggerDataserviceSearch(value: string) {
    if (this.dataserviceSearchTimer) clearTimeout(this.dataserviceSearchTimer);
    const q = (value || '').trim();
    if (q.length === 0) return;
    this.getDataserviceList(q);
  }

  trackByCompany = (_: number, item: { id: string; name: string }) => item.id;

  getDataserviceList(search_text: string) {
    this.searchLoading = true;
    this.adminService.ListDataServicesByCompany(this.company.company, search_text, 1, 10).subscribe({
      next: (res: ServerResponseObject<GetDataServices>) => {
        this.dataservicesOptions = (res.result?.dataservices || []).map(c => ({ id: c.id, name: c.name }));
        this.searchLoading = false;
      },
      error: () => {
        this.dataservicesOptions = [];
        this.searchLoading = false;
      }
    });
  }
}
